import { GameBadgesConfig } from './types';
import { DropWinsBadge } from './components/GameBadges/components/DropWinsBadge';

const DROPS_AND_WINS_CATEGORY = 587;

/** Структура описывающая какие бейджи выводятся для каких ID категорий.
 * Представляет собой массив, в котором находятся объекты конфигов, т.е. массив конфигов - таким
 * образом достигается приоритетность вывода бейджей (например, если игра состоит в категории Drops'n'Wins,
 * то бейджи top, new, bonus не должны выводиться и т.п.)
 * Каждый конфиг представляет собой ключ, который id категории с бэкенда и значение, которое содержит
 * компонент и функцию для определения условия виден этот бейдж или нет.
 */
export const GAME_BADGES: GameBadgesConfig[] = [
  {
    [DROPS_AND_WINS_CATEGORY]: {
      getCondition: (gameCategories) => {
        return gameCategories.some((c) => c.id === DROPS_AND_WINS_CATEGORY);
      },
      component: () => <DropWinsBadge />
    }
  },
  /** в будущем добавлять остальные badges сюда */
  {}
];
